import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney, formatMoneyShorten, formatDate } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting } from 'react-icons/ai';
import { MdPerson } from 'react-icons/md';
import { RiLockPasswordLine } from 'react-icons/ri';
import { FaAward } from 'react-icons/fa';
import { AiOutlineUser, AiFillStar } from 'react-icons/ai';
import { GAME_TYPES } from '../Constants';
import { callGameServerApi } from '../Helpers';
import { PLAY_MODES } from '../Constants';
import { IoPersonAddSharp } from 'react-icons/io5';
import { BsChatDotsFill } from 'react-icons/bs';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ userData, setUserData ] = useState(null);
  const [ id, setId ] = useState(props.id);
  const [ username, setUsername ] = useState("");
  const [ showForm1, setShowForm1 ] = useState(false);
  const [ gameType1, setGameType1 ] = useState(GAME_TYPES.LASTCARD);
  const [ showForm2, setShowForm2 ] = useState(false);
  const [ gameId, setGameId ] = useState('');

  const [ isFriend, setIsFriend ] = useState(false);
  const [ hasRequestedFriendship, setHasRequestedFriendship ] = useState(false);
  const [ isFriendRequestSent, setIsFriendRequestSent ] = useState(false);


  const getUserData = async () => {
    setLoading(true);
    await callGameServerApi('get-user-public-data', { id }).then((response) => {
      setLoading(false);
      if(response.status === 1) {
        setUserData(response.userData);
      }
    })
  }

  function isFriendChecker() {
    if(appContext.userData && userData) {
      JSON.parse(appContext.userData.friends).forEach((item, i) => {
        if(Number(item.id) === Number(userData.id)) {
          setIsFriend(true);
        }
      });
    } else {
      setIsFriend(false);
    }
  }

  function isFriendRequestSentChecker() {
    
    if(appContext.userData && userData) {
      JSON.parse(userData.friendRequests).forEach((item, i) => {
        if(Number(item.id) === Number(appContext.userData.id)) {
          setIsFriendRequestSent(true);
        }
      });
    } else {
      setIsFriendRequestSent(false);
    }
  }

  function hasRequestedFriendshipChecker() {
    if(appContext.userData && userData) {
      JSON.parse(appContext.userData.friendRequests).forEach((item, i) => {
        if(Number(item.id) === Number(userData.id)) {
          setHasRequestedFriendship(true);
        }
      });
    } else {
      setHasRequestedFriendship(false);
    }
  }

  async function startChat() {
    setLoading(true);
    await callGameServerApi("start-chatroom", { guestId: id, type: 'normal' }).then((response) => {
      if(response.status === 1) {
        //take to chat
        appContext.navTo({
          item: 'chatroom',
          subItem: response.chatRoomId,
        })
      } else {
        appContext.tellError(response.msg);
      }
    })
    setLoading(false);
  }


  const createMatch = async () => {
    //create match for the selected game
    if(!loading) {
      setLoading(true);
      let user = await appContext.getLocalUser();
      //console.log(user);
      await callGameServerApi(
        'create-game', 
        { 
          playerId: user.userId,
          userToken: user.userToken,
          invitedId: Number(id),
          playMode: PLAY_MODES.ONLINE,
          gameType: gameType1,
        }).then(response => {
        if(response.status === 1) {
          appContext.navTo({
            item: 'browse_game',
            subItem: response.uid,
          });
        } else {
          setLoading(false);
          appContext.tellError(response.msg);
          
        }
      })
    }
  }

  const inviteUser = async () => {
    //invite user to a game
    if(!loading) {
      setLoading(true);
      await callGameServerApi('invite-user-to-game', { gameId, invitedId: userData.id }).then(response => {
        if(response.status === 1) {
          appContext.tellMessage(userData['username']+" was successfully invited")
          setShowForm2(false);
          setLoading(false);
        } else {
          setLoading(false);
          appContext.tellError(response.msg);
        }
      })
    }
  }

  const sendFriendRequest = async () => {
    //send friend request
    setLoading(true);
    await callGameServerApi("send-friend-request", { requestedUserId: id, }).then((response) => {
      if(response.status === 1) {
        appContext.tellMessage(`Friend request to ${username}  was sent successfully`)
        appContext.getUserData();
        getUserData();
      } else {
        appContext.tellError(response.msg);
      }
    })
    setLoading(false);
  }

  const acceptFriendRequest = async () => {
    //send friend request
    setLoading(true);
    await callGameServerApi("accept-friend-request", { requesterUserId: id, }).then((response) => {
      if(response.status === 1) {
        appContext.tellMessage(`${username} is now your friend`);
        appContext.getUserData();
        getUserData();
      } else {
        appContext.tellError(response.msg);
      }
    })
    setLoading(false);
  }

  const init = async () => {
    setReady(false);
    appContext.changeOrientation(requiredOrientation);
    await getUserData();
    setReady(true);
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  useEffect(() => {
    setId(props.id);
  }, [ props.id ])

  useEffect(() => {
    init();
  }, [ id ])

  useEffect(() => {
    if(userData) {
      setUsername(userData.username);
    }

    isFriendChecker();
    hasRequestedFriendshipChecker();
    isFriendRequestSentChecker();
  }, [ appContext.userData, userData, ])

  if(ready) {
    return (
      <>
        <TopBar title="User Profile"/>
        <div className="FullPane"  data-support-top-bar={true}>
          <div className="container" style={{ paddingBottom: "50px" }}>
            <div className="row">

              <div className="col-md-12 col-sm-12" style={{ marginTop: "10px" }}>
                <div className='card'>
                  <div className='card-body z-depth-1 text-center'>
                    <MdPerson size={70}/>
                    <h5 className='font-light' style={{ textTransform: "capitalize" }}>{userData.username}</h5>
                    {
                      ((Date.now()/1000) - Number(userData.lastSeen) <= (60 * 5)) ?
                      <small className='text-success font-bold'>Online now</small>
                      :
                      <small className='text-muted font-light'>Last Seen: {formatDate(userData.lastSeen)}</small>
                    }

                    {
                      (isFriend) ?
                      <div className='text-center'>
                        <button
                          className='btn bg-faint-black btn-sm'
                          onClick={startChat}
                        >
                          <BsChatDotsFill size={30}/>
                        </button>
                      </div>
                      :
                      ""
                    }
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-sm-12" style={{ marginTop: "10px", borderBottom: "1px solid var(--faintBlack)" }}>
                <div className='d-flex justify-content-between'>
                  <h4 className='align-self-center'>
                    <AiFillStar size={30} color="var(--goldish)"/> {formatMoneyShorten(JSON.parse(userData.stars).length)}
                  </h4>

                  <h4 className='align-self-center'>
                    {formatMoneyShorten(userData.points)} <span className='text-bluish'>&nbsp;Points</span>
                  </h4>
                </div>

                <div className='text-end' style={{ marginTop: "20px", marginBottom: "20px" }}>
                  {
                    (isFriend) ?
                    <h6 style={{ fontSize: "12px" }} className='text-goldish'>
                      Friends
                    </h6>
                    :
                    (hasRequestedFriendship) ?
                    <button
                      className='btn btn-sm bg-goldish'
                      onClick={acceptFriendRequest}
                    >
                      Accept Friend Request&nbsp;<IoPersonAddSharp size={20}/>
                    </button>
                    :
                    (isFriendRequestSent) ?
                    <h6 style={{ fontSize: "12px" }} className='text-redish'>
                        Friend Request sent
                    </h6>
                    :
                    (appContext.userData && Number(appContext.userData.id) !== Number(id)) ?
                    <button
                      className='btn btn-sm bg-bluish'
                      onClick={sendFriendRequest}
                    >
                      Send Friend Request&nbsp;<IoPersonAddSharp size={20}/>
                    </button>
                    : ""
                  }

                 
                </div>
              </div>

              <div className="col-6" style={{ marginTop: "10px" }}>

                <div className='text-start z-depth-1' style={{ padding: '10px', marginTop: "10px" }}>
                  <h1 className='font-light' style={{ fontSize: "40px" }}>
                    {JSON.parse(userData.stars).filter((item) => {
                      if(item.gameType === 'arubastini') {
                        return item;
                      }
                    }).length}
                  </h1>
                  <small className='text-muted form-text'>Arubastini Championships</small>
                </div>

                <div className='text-start z-depth-1' style={{ padding: '10px', marginTop: "10px" }}>
                  <h1 className='font-light' style={{ fontSize: "40px" }}>
                    {JSON.parse(userData.stars).filter((item) => {
                      if(item.gameType === 'lastcard') {
                        return item;
                      }
                    }).length}
                  </h1>
                  <small className='text-muted form-text'>LastCard Championships</small>
                </div>          

              </div>

              <div className="col-6" style={{ marginTop: "10px" }}>

                <div className='text-start z-depth-1' style={{ padding: '10px', marginTop: "10px" }}>
                  <h1 className='font-light' style={{ fontSize: "40px" }}>
                    {JSON.parse(userData.stars).filter((item) => {
                      if(item.gameType === 'brazilian') {
                        return item;
                      }
                    }).length}
                  </h1>
                  <small className='text-muted form-text'>Brazilian Checkers Championships</small>
                </div>

                <div className='text-start z-depth-1' style={{ padding: '10px', marginTop: "10px" }}>
                  <h1 className='font-light' style={{ fontSize: "40px" }}>
                    {JSON.parse(userData.stars).filter((item) => {
                      if(item.gameType === 'spanish') {
                        return item;
                      }
                    }).length}
                  </h1>
                  <small className='text-muted form-text'>Spanish Checkers Championships</small>
                </div>          

              </div>

              {
                (userData.id !== appContext.userData.id) ?
                <>
                  <div className="col-md-12 col-sm-12 text-center" style={{ marginTop: "20px" }}>
                    {
                      (showForm1) ?
                      <div className='text-start'>
                        <div className='form-group'>
                          <label>Select Game Type</label>
                          <select className='form-control' value={gameType1} onChange={(e) => setGameType1(e.target.value)}>
                            <option value={GAME_TYPES.LASTCARD} >Cards - LastCard</option>
                            <option value={GAME_TYPES.ARUBASTINI} >Cards - Arubastini</option>
                            <option value={GAME_TYPES.BRAZILIAN_CHECKERS} >Brazilian Checkers</option>
                            <option value={GAME_TYPES.SPANISH_CHECKERS} >Spanish Checkers</option>
                          </select>
                          
                        </div>

                        <div className='form-group text-end'>
                          <button
                            className='btn btn-rounded bg-dark'
                            onClick={() => {
                              appContext.activateDialog({
                                message: "Are you sure you want to host and invite this user?",
                                onConfirm: () => createMatch(),
                              })
                            }}
                          >
                            Host and Invite {userData.username}
                          </button>
                        </div>
                      </div> 
                      :
                      <button
                        className='btn btn-rounded bg-bluish'
                        onClick={() => {
                          setShowForm1(true);
                          setShowForm2(false);
                        }}
                        style={{
                          padding: "15px"
                        }}
                      >
                        Host a Match and Invite <span style={{ textTransform: "capitalize" }}>{userData.username}</span>
                      </button>
                    }
                  </div>

                  <div className="col-md-12 col-sm-12 text-center" style={{ marginTop: "20px" }}>
                    <h6 className='text-muted text-center'>Or</h6>
                  </div>

                  <div className="col-md-12 col-sm-12 text-center" style={{ marginTop: "20px" }}>
                    
                    {
                      (showForm2) ?
                      <div className='text-start'>
                        <div className='form-group'>
                          <label>Write Game ID</label>
                          <input className='form-control' value={gameId} onChange={(e) => setGameId(e.target.value.trim())}/>
                          <small className='form-text'>Write ID of the game you've hosted but not yet joined by an opponent</small>
                        </div>

                        <div className='form-group text-end'>
                          <button
                            className='btn btn-rounded bg-dark'
                            onClick={() => {
                              appContext.activateDialog({
                                message: "Are you sure you want to invite this user?",
                                onConfirm: () => inviteUser(),
                              })
                            }}
                          >
                            Invite {userData.username}
                          </button>
                        </div>
                      </div> 
                      :
                      <button
                        className='btn btn-rounded bg-goldish'
                        style={{
                          padding: "15px"
                        }}
                        onClick={() => {
                          setShowForm1(false);
                          setShowForm2(true);
                        }}
                      >
                        Invite <span style={{ textTransform: "capitalize" }}>{userData.username}</span> in your hosted match
                      </button>
                    }
                    
                    
                  </div>
                </> 
                : ""
              }

            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
